import { CDN_URL } from '@config/environment';

const createCdnLink = (path: string) => {
    const link = `${CDN_URL}/${path}`;

    return link;
};

export { createCdnLink };
